<div class="grid-container padding-y-4">
  <form [formGroup]="xtosShipmentForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="carrierId" class="usa-label">SCAC<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <select id="carrierId" class="usa-select" formControlName="carrierId">
            <option [ngValue]="null">..SCAC..</option>
            <option [ngValue]="carrier.carrierId" *ngFor="let carrier of carriers">{{ carrier.scac }}
            </option>
          </select>
          <div *ngIf="xtosShipmentForm.get('carrierId').invalid && (xtosShipmentForm.get('carrierId').touched
                      || xtosShipmentForm.get('carrierId').dirty) && xtosShipmentForm.get('carrierId').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> SCAC is required!
          </div>
        </div>
        <!--<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="storageStateId" class="usa-label">Storage Location<abbr title="required"
              class="usa-hint usa-hint&#45;&#45;required">*</abbr></label>
          <select id="storageStateId" class="usa-select" formControlName="storageStateId">
            <option [ngValue]="null">..Storage Location..</option>
            <option [ngValue]="state.stateCountryId" *ngFor="let state of states">{{ state.stateCountryName }}
            </option>
          </select>
          <div *ngIf="xtosShipmentForm.get('storageStateId').invalid && (xtosShipmentForm.get('storageStateId').touched
                      || xtosShipmentForm.get('storageStateId').dirty) && xtosShipmentForm.get('storageStateId').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Storage location is required!
          </div>
        </div>-->
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="storageType" class="usa-label">Storage Type<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <select id="storageType" class="usa-select" formControlName="storageType">
            <option [ngValue]="null">..Storage Type..</option>
            <option [ngValue]="storageType" *ngFor="let storageType of storageTypes">{{ storageType }}
            </option>
          </select>
          <div *ngIf="xtosShipmentForm.get('storageType').invalid && (xtosShipmentForm.get('storageType').touched
                      || xtosShipmentForm.get('storageType').dirty) && xtosShipmentForm.get('storageType').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Storage type is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="storageType" class="usa-label">SRO Code<abbr title="required"
                                                                       class="usa-hint usa-hint--required">*</abbr></label>
          <select id="sroMasterId" class="usa-select" formControlName="sroMasterId">
            <option [ngValue]="null">..SRO Code..</option>
            <option [ngValue]="sro.sroMasterId" *ngFor="let sro of sroCodes">{{ sro.sroId }}
            </option>
          </select>
          <div *ngIf="xtosShipmentForm.get('sroMasterId').invalid && (xtosShipmentForm.get('sroMasterId').touched
                      || xtosShipmentForm.get('sroMasterId').dirty) && xtosShipmentForm.get('sroMasterId').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> SRO code is required!
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="packingDate" class="usa-label">Pick Up Date<abbr title="required"
                                                                       class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="packingDate" class="usa-input" formControlName="packingDate" name="packingDate"
                 [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                 bsDatepicker placement="right" placeholder="Pick Up Date" />
          <div *ngIf="xtosShipmentForm.get('packingDate').invalid && (xtosShipmentForm.get('packingDate').touched
                      || xtosShipmentForm.get('packingDate').dirty) && xtosShipmentForm.get('packingDate').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Packing Date is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="dateIntoExtraStorage" class="usa-label">Date into Extended Storage<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="dateIntoExtraStorage" class="usa-input" formControlName="dateIntoExtraStorage" name="dateIntoExtraStorage"
                 [bsConfig]="{containerClass: 'theme-dark-blue',showWeekNumbers: false}" (bsValueChange)="onPackingXtosDateChange($event)"
                 bsDatepicker placement="bottom" placeholder="Date into Extended Storage" />
          <div *ngIf="xtosShipmentForm.get('dateIntoExtraStorage').invalid &&(xtosShipmentForm.get('dateIntoExtraStorage').touched
                      || xtosShipmentForm.get('dateIntoExtraStorage').dirty) && xtosShipmentForm.get('dateIntoExtraStorage').errors.required"
               class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Date into Extra Storage is required!
          </div>
          <div *ngIf="showPackingDateError" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> {{packingDateError}}
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="packingDate" class="usa-label">Billing Date<abbr title="required"
                                                                       class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="billingDate" class="usa-input" formControlName="billingDate" name="billingDate" (bsValueChange)="onBillingDateChange($event)"
                 [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                 bsDatepicker placement="right" placeholder="Billing Date" />
          <div *ngIf="xtosShipmentForm.get('billingDate').invalid && (xtosShipmentForm.get('billingDate').touched
                      || xtosShipmentForm.get('billingDate').dirty) && xtosShipmentForm.get('billingDate').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Billing Date is required!
          </div>
          <div *ngIf="showBillingDateError" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> {{billingDateError}}
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="bolNumber" class="usa-label">BOL Number<abbr title="required"
                                                                          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter BL number" id="bolNumber" class="usa-input"
                 formControlName="bolNumber" />
          <div *ngIf="xtosShipmentForm.get('bolNumber').invalid && (xtosShipmentForm.get('bolNumber').touched
                      || xtosShipmentForm.get('bolNumber').dirty) && xtosShipmentForm.get('bolNumber').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> BL Number is required!
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <ng-template #customItemTemplate let-model="item">{{model.cityName}},
            {{model.stateAbbrev}} {{model.zipCode}}
          </ng-template>
          <label for="OriginSearchString" class="usa-label">Storage Zip<abbr title="required"
                                                                             class="usa-hint usa-hint&#45;&#45;required">*</abbr> </label>
          <input
            id="OriginSearchString1" class="usa-input"
            formControlName="storageZipId"
            [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
            (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
            (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
            typeaheadOptionField="zipCode"
            [typeaheadItemTemplate]="customItemTemplate"
            [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
            [typeaheadOptionsInScrollableView]="10"
            [typeaheadOptionsLimit]="100"
            placeholder="Enter a location or zip">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="city" class="usa-label">City
            <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
          </label>
          <input
            id="city"
            type="text"
            formControlName="city"
            name="city"
            class="usa-input"
            placeholder="Enter city"
          />
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="state" class="usa-label">State
            <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>
          </label>
          <input
            id="state"
            type="text"
            formControlName="state"
            name="state"
            class="usa-input"
            placeholder="Enter State"
          />
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="zipCode" class="usa-label">Zip Code
            <abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr>

          </label>
          <input
            id="zipCode"
            type="text"
            name="zipCode"
            formControlName="zipCode"
            class="usa-input"
            placeholder="Enter Zip / Pin"
          />
        </div>
      </div>
      <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="storageStreetAddr" class="usa-label">Storage Address<abbr title="required"
                                                                 class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Storage Address" id="storageStreetAddr" class="usa-input"
                 formControlName="storageStreetAddr" />
          <div *ngIf="xtosShipmentForm.get('storageStreetAddr').invalid && (xtosShipmentForm.get('storageStreetAddr').touched
                      || xtosShipmentForm.get('storageStreetAddr').dirty) && xtosShipmentForm.get('storageStreetAddr').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Storage Address is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="passThruAmount" class="usa-label">Pass Thru Amount</label>
          <input type="text" placeholder="Enter Pass Thru Amount" id="passThruAmount" class="usa-input"
                 formControlName="passThruAmount" />
          <div *ngIf="xtosShipmentForm.get('passThruAmount').invalid && (xtosShipmentForm.get('passThruAmount').touched
                      || xtosShipmentForm.get('passThruAmount').dirty) && xtosShipmentForm.get('passThruAmount').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Pass Thru Amount is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="amountInvoiced" class="usa-label">Total Amount Invoiced<abbr title="required"
                                                                                   class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Amount Invoiced" id="amountInvoiced" class="usa-input"
                 formControlName="amountInvoiced" />
          <div *ngIf="xtosShipmentForm.get('amountInvoiced').invalid && (xtosShipmentForm.get('amountInvoiced').touched
                      || xtosShipmentForm.get('amountInvoiced').dirty) && xtosShipmentForm.get('amountInvoiced').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Amount Invoiced is required!
          </div>
          <div class="define-text-secondary" *ngIf="xtosShipmentForm.get('amountInvoiced').touched &&
          xtosShipmentForm.get('amountInvoiced').hasError('greaterThanZero')">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Amount Invoiced should be greater than zero
          </div>
          <div class="define-text-secondary" *ngIf="xtosShipmentForm.get('amountInvoiced').touched &&
          xtosShipmentForm.get('amountInvoiced').hasError('notDecimal')">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Amount Invoiced should be dollars and cents eg: 1.00
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="reportingYear" class="usa-label">Rpt Year<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="reportingYear" class="usa-input" formControlName="reportingYear" name="reportingYear" [maxDate]="maxDate"
          [bsConfig]="{containerClass: 'theme-dark-blue',dateInputFormat: 'YYYY',minMode: 'year'}" (bsValueChange)="onReportingYearChange($event)"
          bsDatepicker placement="right" placeholder="Reporting year" />
          <div *ngIf="xtosShipmentForm.get('reportingYear').invalid && (xtosShipmentForm.get('reportingYear').touched
                      || xtosShipmentForm.get('reportingYear').dirty) && xtosShipmentForm.get('reportingYear').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Reporting Year is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="reportingQuarter" class="usa-label">Rpt Qtr<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <select id="reportingQuarter" class="usa-select" formControlName="reportingQuarter">
            <option [ngValue]="null">..Reporting Quarter..</option>
            <option *ngFor="let qtr of this.printQtrList" [value]="qtr.value">{{qtr.name}}</option>
          </select>
          <div *ngIf="xtosShipmentForm.get('reportingQuarter').invalid && (xtosShipmentForm.get('reportingQuarter').touched
                      || xtosShipmentForm.get('reportingQuarter').dirty) && xtosShipmentForm.get('reportingQuarter').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Reporting Quarter is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="referenceNumber" class="usa-label">Reference #<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Reference number" id="referenceNumber" class="usa-input"
            formControlName="referenceNumber" />
          <div *ngIf="xtosShipmentForm.get('referenceNumber').invalid && (xtosShipmentForm.get('referenceNumber').touched
                      || xtosShipmentForm.get('referenceNumber').dirty) && xtosShipmentForm.get('referenceNumber').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Reference Number is required!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="shipmentWeight" class="usa-label">Shipment Weight<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Weight" id="shipmentWeight" class="usa-input"
            formControlName="shipmentWeight" />
          <div *ngIf="xtosShipmentForm.get('shipmentWeight').invalid && (xtosShipmentForm.get('shipmentWeight').touched
                      || xtosShipmentForm.get('shipmentWeight').dirty) && xtosShipmentForm.get('shipmentWeight').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Shipment weight is required!
          </div>
          <div class="define-text-secondary" *ngIf="xtosShipmentForm.get('shipmentWeight').touched &&
          xtosShipmentForm.get('shipmentWeight').hasError('min')">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Shipment weight should be greater than zero
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="faicCode" class="usa-label">Agency FAIC<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Agency FAIC" id="faicCode" class="usa-input" maxlength='10'
            formControlName="faicCode" />
          <div *ngIf="xtosShipmentForm.get('faicCode').invalid && (xtosShipmentForm.get('faicCode').touched
                      || xtosShipmentForm.get('faicCode').dirty) && xtosShipmentForm.get('faicCode').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Agency FAIC is required!
          </div>
          <div *ngIf="xtosShipmentForm.get('faicCode').invalid && (xtosShipmentForm.get('faicCode').touched
                      || xtosShipmentForm.get('faicCode').dirty) && xtosShipmentForm.get('faicCode').errors.minlength" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Agency FAIC must be 10 chars long!
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="employeeLastName" class="usa-label">Employee Last Name<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter employee last name" id="employeeLastName" class="usa-input"
            formControlName="employeeLastName" />
          <div *ngIf="xtosShipmentForm.get('employeeLastName').invalid && (xtosShipmentForm.get('employeeLastName').touched
                      || xtosShipmentForm.get('employeeLastName').dirty) && xtosShipmentForm.get('employeeLastName').errors.required" class="define-text-secondary">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Employee last name is required!
          </div>
          <div class="define-text-secondary" *ngIf="xtosShipmentForm.get('employeeLastName').touched &&
          xtosShipmentForm.get('employeeLastName').hasError('pattern')">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Please enter only characters
          </div>
        </div>
      </div>
      <div class="grid-row margin-top-2 buttonGrp">
        <ul class="usa-button-group">
          <!--<li class="usa-button-group__item">
            <button [disabled]="isXTOSShipmentSelected === false" class="usa-button usa-button&#45;&#45;secondary" (click)="delete()">Delete</button>
          </li>-->
          <!--<li class="usa-button-group__item">
            <button [disabled]="xtosShipmentForm.invalid || isXTOSShipmentSelected === false" class="usa-button" (click)="modify()">Modify</button>
          </li>-->
          <li class="usa-button-group__item">
            <button [disabled]="xtosShipmentForm.invalid" class="usa-button" (click)="addToList()">Save</button>
          </li>
        </ul>
      </div>
    </fieldset>
  </form>
</div>
